import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    selector: String,
    select: { type: Boolean, default: false },
  }

  connect() {
    // Use setTimeout to ensure DOM is fully updated after Turbo Stream
    setTimeout(() => {
      const element = document.querySelector(this.selectorValue)
      if (element) {
        element.focus()
        if (this.selectValue && element.select) {
          element.select()
        }
      }
      this.element.remove()
    }, 10)
  }
}
